import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FILE_ADD } from '../../actions/types';
import { hasAccess } from '../../utils';
import ButtonUpload from '../../components/ButtonUpload';
import MoveImageToDocumentModal from '../../components/MoveImageToDocumentModal';
import styles from './case.module.scss';

const PictureCase = ({
  selectedCase,
  currentFolder,
  searchParams,
  setSearchParams,
  selectedFiles,
  isLoadingFile,
  handleChangeFile,
  handleDownload,
  handleSend,
  getSourceForFile,
  movePictureToNumber,
  renderDocument,
  matchesNumber,
}) => {
  const { authReducer } = useSelector((store) => store);
  const { user } = authReducer;
  const bulkMoveModalRef = useRef();

  // Retourne true si la picture appartient à la catégorie (pictures param)
  function matchesPictureCategory(f, picturesParam) {
    if (picturesParam === 'hs') return f.type === 'hs';
    if (picturesParam === 'Préparation') {
      return f.taskType === 'Préparation' || (!f.taskType && f.type === 'departure');
    }
    if (picturesParam === 'Déchargement') {
      return f.taskType === 'Déchargement' || (!f.taskType && f.type === 'return');
    }
    return f.taskType === picturesParam;
  }

  function getFilteredPicturesForCategory() {
    return currentFolder.pictures.filter(
      (f) => matchesPictureCategory(f, searchParams.get('pictures')) && matchesNumber(f, searchParams.get('number'), searchParams.get('piecePL')),
    );
  }

  // Un seul élément par file._id (éviter doublons case + task.files)
  function getUniquePicturesByFileId() {
    const seen = new Set();
    return getFilteredPicturesForCategory().filter((p) => {
      const id = p.file?._id;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }

  function renderHeaderPictures(type) {
    let strType;
    if (type === 'departure') strType = 'départ';
    else if (type === 'return') strType = 'retour';
    else if (type === 'hs') strType = 'HS et réparation';
    else if (type === 'Préparation') strType = 'preparation';
    else if (type === 'Chargement') strType = 'chargement';
    else if (type === 'Déchargement') strType = 'déchargement';
    else if (type === 'Retour') strType = 'retour';
    else strType = type;

    const count = getUniquePicturesByFileId().length;
    return (
      `Photo${count > 1 ? 's' : ''} ${` ${strType}`}`
    );
  }

  return (
    <>
      <div className={styles.breadcrumbTrail}>
        <p>
          <NavLink key={`root-${currentFolder._id}`} to={`/case/${selectedCase._id}`}>...</NavLink>
          <span> / </span>
          <a onClick={() => {
            const p = new URLSearchParams(searchParams);
            p.delete('pictures');
            setSearchParams(p);
          }}>{searchParams.get('number')}</a>
          <span> / {renderHeaderPictures(searchParams.get('pictures'))}</span></p>
      </div>
      <div className={styles.header}>
        <h3>Documents</h3>
        <div className={styles.containerButtons}>
          {selectedFiles.length > 0 && (
            <>
              <button
                className={`third ${styles.btnSend}`}
                onClick={() => handleDownload()}
              >
                Télécharger la selection
              </button>
              <button
                className={`third ${styles.btnSend}`}
                onClick={() => handleSend()}
              >
                Envoyer par email
              </button>
              {hasAccess(user.role) && movePictureToNumber && getSourceForFile && (
                <>
                  <button
                    type="button"
                    className={`third ${styles.btnSend}`}
                    onClick={() => bulkMoveModalRef.current?.open?.()}
                  >
                    Déplacer la sélection
                  </button>
                  <MoveImageToDocumentModal
                    ref={bulkMoveModalRef}
                    fileIds={selectedFiles}
                    pictureType={searchParams.get('pictures')}
                    getSourceForFile={getSourceForFile}
                    onSubmitTransfer={movePictureToNumber}
                  />
                </>
              )}
            </>
          )}
          {hasAccess(user.role) && (
            <ButtonUpload
              isLoading={isLoadingFile.includes(FILE_ADD)}
              handleChangeFile={handleChangeFile}
            />
          )}
        </div>
      </div>
      {currentFolder.pictures.length > 0 && (
        renderDocument(getUniquePicturesByFileId().map((d) => d.file), { enableMove: true })
      )}
    </>
  );
};

export default PictureCase;
